export const AnswerOptionStatus = {
    UNDEFINED: 'undefined',
    CORRECT: 'correct',
    INCORRECT: 'incorrect',
    OK: 'ok'
};
